import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4">
      {categories.map((c) => (
        <a
          key={c.id}
          href={c.href}
          target="_blank"
          rel="noopener nofollow"
          className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-0.5 hover:border-primary-300"
        >
          <div className="relative h-36 w-full overflow-hidden md:h-44">
            <img
              src={c.image}
              alt={`${t(c.nameKey)} — USFans Spreadsheet`}
              className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
            />
          </div>
          <div className="flex items-center justify-between gap-2 p-3 md:p-4">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-base text-secondary-700 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700">
                <i className={c.icon}></i>
              </span>
              <span className="font-heading text-sm font-semibold text-foreground-900 md:text-base">
                {t(c.nameKey)}
              </span>
            </div>
            <span className="flex h-4 w-4 shrink-0 items-center justify-center text-primary-600 transition-transform group-hover:translate-x-0.5">
              <i className="ri-arrow-right-line"></i>
            </span>
          </div>
        </a>
      ))}
    </div>
  );
}